<template>
  <div>
    <KTCodePreview v-bind:title="'In Biên nhận sửa chữa'">
      <template v-slot:toolbar>
        <b-button
          variant="primary"
          size="sm"
          class="font-weight-bolder"
          @click="onClickToPrint"
          :disabled="!renderComponent"
        >
          <i
            style="font-size: 1rem"
            class="fas fa-print"
          ></i>In biên nhận
        </b-button>
      </template>
      <template v-slot:preview>
        <hr
          class="hr-text"
          data-content="Khổ giấy A5"
          style="font-weight: 600"
        />
        <div
          id="repair-receipt-area"
          v-if="renderComponent"
        >
          <PrintRepairReceipt :slip="slip" />
        </div>
        <br />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import { TIME_TRIGGER } from '@/utils/constants';
import { makeToastFaile } from '@/utils/common';
import PrintRepairReceipt from '@/view/components/warranty-service/PrintRepairReceipt.vue';

export default {
  name: 'PrintRepairReceiptPage',
  components: {
    KTCodePreview,
    PrintRepairReceipt,
  },
  data() {
    return {
      slip: {},
      renderComponent: false,
    };
  },
  async created() {
    const id = this.$route.query.id || this.$route.params.id;
    if (!id) {
      makeToastFaile('Thiếu mã phiếu');
      return;
    }
    await this.getRepairSlip(id);
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Dịch vụ bảo hành', route: '/warranty-service/repair-slips' },
      { title: 'In biên nhận sửa chữa' },
    ]);
  },
  methods: {
    async getRepairSlip(id) {
      this.renderComponent = false;
      try {
        const { data } = await ApiService.get(`v2/warranty-service/repair-slips/${id}`);
        this.slip = data && data.data ? data.data : {};
        this.renderComponent = true;
      } catch (err) {
        makeToastFaile(err && err.message ? err.message : 'Không tải được phiếu');
      }
    },
    printData(stylePrint) {
      const prtHtml = document.getElementById('repair-receipt-area').innerHTML;
      let stylesHtml = '';
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open(
        '',
        '',
        'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0',
      );
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
            ${stylePrint}
          </head>
          <body>${prtHtml}</body>
        </html>`);
      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(() => {
        WinPrint.print();
      }, TIME_TRIGGER);
    },
    getStylePrint() {
      return `<style>
        @page { size: A4 portrait; margin: 8mm; }
        body { margin: 0; }
      </style>`;
    },
    onClickToPrint() {
      this.printData(this.getStylePrint());
    },
  },
};
</script>
